import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { API_GET_ORGANIZATION_CONFIG, KEY_GET_ORGANIZATION_CONFIG } from '../constants';
import { MOCK_RESPONSE_GET_ORGANIZATION_CONFIG } from '../mocks';
import { getCurrentOrganization } from '../selectors';
import { OrganizationConfig } from '../types';

export type CallParamsGetOrganizationConfig = {
  successSaga?: CallbackSaga<
    object,
    CallResponseGetOrganizationConfig,
    CallErrorGetOrganizationConfig,
    CallSelectorsGetOrganizationConfig
  >;
  errorSaga?: CallbackSaga;
};

type CallResponseGetOrganizationConfig = OrganizationConfig;

type CallErrorGetOrganizationConfig = {
  message: string;
  code: number;
};

type CallSelectorsGetOrganizationConfig = {
  userMustConfigureOrganization: boolean;
};

export const getOrganizationConfigCall = createGeneralCall<
  CallParamsGetOrganizationConfig,
  CallResponseGetOrganizationConfig,
  CallErrorGetOrganizationConfig,
  CallSelectorsGetOrganizationConfig
>({
  id: KEY_GET_ORGANIZATION_CONFIG,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_ORGANIZATION_CONFIG(org as unknown as string);
  },
  method: 'get',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_ORGANIZATION_CONFIG : undefined,
  selectors: {
    userMustConfigureOrganization: ({ selectors }) =>
      createSelector(selectors.response, res => !res?.hasViewConfig || false),
  },
});
